@if (showHeader()) {
  <div class="tt-compare-flowchart_header" [class.tt-compare-flowchart_header--compare]="compareMode()">
    @if (compareMode()) {
      <div class="tt-compare-flowchart_header-local">
        @if (!mergeConflictStatus()) {
          {{ 'SingleGuidelineManager.ImportedGuideline.Editor.LocalFlowchart' | transloco }}
        } @else {
          <button ttButton [size]="'xSmall'" [variant]="'outline'" (click)="handleAcceptLocalClicked()"
            >{{ 'SingleGuidelineManager.ImportedGuideline.Editor.TakeLocalChanges' | transloco }}
          </button>
        }
      </div>
      <div class="tt-compare-flowchart_divider">
        @if (hasLocalChanges()) {
          <mat-icon
            class="tt-compare-flowchart_divider-icon"
            [icon]="'chevrons-left'"
            [iconSize]="14"
            [ttTooltip]="'SingleGuidelineManager.ImportedGuideline.Editor.RevertToOriginalTooltip' | transloco"
            (click)="revertLocalFlowchart()" />
        }
      </div>
      <div class="tt-compare-flowchart_header-original">
        @if (mergeConflictStatus() !== 'conflict') {
          {{ 'SingleGuidelineManager.ImportedGuideline.Editor.OriginalFlowchart' | transloco }}
        } @else {
          <button ttButton [size]="'xSmall'" [variant]="'outline'" (click)="handleAcceptOriginalClicked()">
            {{ 'SingleGuidelineManager.ImportedGuideline.Editor.TakeOriginalChanges' | transloco }}
          </button>

          <common-chip class="tt-smartbook_merge-conflict" [variant]="'' + 'inactive'">
            {{ 'GuidelineUpdateTag.MergeConflict' | transloco }}
          </common-chip>
        }
      </div>
    }

    @if (mergeConflictStatus() === 'resolved') {
      <common-chip class="tt-compare-flowchart_header-resolved" [clickable]="true" [ttMenuTriggerFor]="menu" [variant]="'inprogress'"
        >{{ 'GuidelineUpdateTag.MergeResolved' | transloco }}
      </common-chip>
    }
  </div>
}

<div class="tt-compare-flowchart">
  <span class="tt-compare-flowchart_local">
    @if (renderFlowchart()) {
      @if (!editMode()) {
        <tt-flowchart
          class="tt-smartbook-flowchart_compare-local"
          [allowEvents]="false"
          [flowchartElements]="!!local() ? local() : original()"
          [flowchartId]="flowchartId()"
          (exportButtonClicked)="handleExportFlowchart($event)"
          (exportPdfButtonClicked)="handleExportPdfFlowchart($event)" />
      } @else {
        <tt-flowchart
          class="tt-smartbook-flowchart_compare-local"
          [allowEvents]="true"
          [flowchartElements]="!!local() ? local() : original()"
          [flowchartId]="flowchartId()"
          (exportButtonClicked)="handleExportFlowchart($event)"
          (exportPdfButtonClicked)="handleExportPdfFlowchart($event)"
          (flowchartElementsChange)="handleLocalChanged($event)" />
      }
    } @else {
      <tt-spinner class="tt-compare-flowchart_local-spinner" [size]="48" />
    }
  </span>

  @if (compareMode()) {
    <div class="tt-compare-flowchart_divider"></div>
    <span class="tt-compare-flowchart_original">
      <tt-flowchart
        class="tt-smartbook-flowchart_compare-local"
        [allowEvents]="false"
        [flowchartElements]="original()"
        [flowchartId]="flowchartId()"
        (exportButtonClicked)="handleExportFlowchart($event)"
        (exportPdfButtonClicked)="handleExportPdfFlowchart($event)" />
    </span>
  }
</div>

<tt-menu #menu>
  <button ttMenuItem (click)="conflictUnresolved.emit()">
    {{ 'SingleGuidelineManager.ImportedGuideline.Editor.UndoResolve' | transloco }}
  </button>
</tt-menu>
